import { Component } from 'vue';
import { ImageInfo } from '../../proto/';

export type TextNode = {
  type: TextNodeType,
  text: string,
  innerText: string,
  displayText: string,
  element: Text | HTMLButtonElement | HTMLImageElement,
  isValid?: boolean, // 默认没有，主要校验##频道和##图片是否合规isValid=false
};

export enum TextNodeType {
  normal,
  url,
  emotion,
  mentionMember,
  commonLink,
  picture,
  botCommand
}

export enum CommonLinkTextNodeType {
  unknown,
  channelLink, // 频道跳转
  webLink, // web跳转
  botConfigLink, // 机器人配置跳转
  appLink, // app页面通转
  botWebLink, // 机器人h5页面跳转
  botConfigWithParamLink, // 机器人配置页带参数跳转
}

export interface MentionMemberCommonLinkTextNode {
  uid: number,
  nickName: string
}

export enum EditPanelEmotionCateType {
  emoji,
  sticker,
}

export interface EditPanelEmotionCateItem {
  type: EditPanelEmotionCateType,
  icon: string,
  component: Component,
}

export interface EmojiItem {
  id: string,
  name: string,
  symbol: string
}

export interface ImageSize {
  width: number,
  height: number
}

export interface RealImageInfo extends ImageInfo {
  realWidth: number,
  realHeight: number,
}

